
import Vue from 'vue';
import '@/assets/css/helpdesk/helpdesk-theme.css';
import Component from 'vue-class-component';
import {namespace} from 'vuex-class';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import {ISpamSender} from '@/store/modules/helpdeskSpamModule';

const mod = namespace('helpdeskSpamModule');

@Component({name: 'HelpdeskSpamSenders', components: {PaginationBar}})
export default class HelpdeskSpamSenders extends Vue {
  @mod.Getter('senders')     private senders!: ISpamSender[];
  @mod.Getter('currentPage') private currentPage!: number;
  @mod.Getter('lastPage')    private lastPage!: number;
  @mod.Getter('total')       private total!: number;
  @mod.Getter('perPage')     private perPage!: number;

  private newValue        = '';
  private search          = '';
  private searchTimer: any = null;
  private confirmDelete   = false;
  private deleteTarget: ISpamSender | null = null;
  private selectedPerPage = 15;
  private subscribes: any = {};

  private headers = [
    {text: 'Email / Dominio', value: 'value'},
    {text: 'Añadido',         value: 'created_at', width: 160},
    {text: '',                value: 'actions',    sortable: false, width: 72, align: 'end'},
  ];

  created() {
    this.subscribes = (this as any).$ons({
      'backend.call.OK.spamSendersLoaded': () => {},
      'backend.call.KO.spamSendersLoaded': () => {},
      'backend.call.OK.spamSenderCreated': () => { this.newValue = ''; this.loadData(); },
      'backend.call.OK.spamSenderDeleted': () => { this.loadData(); },
    });
    this.loadData();
  }

  beforeDestroy() { (this as any).$offs(this.subscribes); }

  loadData() {
    const params: any = {page: this.currentPage, per_page: this.selectedPerPage};
    if (this.search) params.search = this.search;
    this.$store.dispatch('helpdeskSpamModule/fetchSenders', params);
  }

  private onPageChange(page: number) {
    const params: any = {page, per_page: this.selectedPerPage};
    if (this.search) params.search = this.search;
    this.$store.dispatch('helpdeskSpamModule/fetchSenders', params);
  }

  private onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.loadData(), 400);
  }

  private onSearchClear() {
    this.search = '';
    this.loadData();
  }

  private onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.loadData();
  }

  private onAdd() {
    if (!this.newValue) return;
    this.$store.dispatch('helpdeskSpamModule/createSender', this.newValue.trim());
  }

  private onDelete(item: ISpamSender) {
    this.deleteTarget = item;
    this.confirmDelete = true;
  }

  private doDelete() {
    if (!this.deleteTarget) return;
    this.confirmDelete = false;
    this.$store.dispatch('helpdeskSpamModule/deleteSender', this.deleteTarget.id);
  }

  private formatDate(date: string): string {
    if (!date) return '—';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: '2-digit'}) +
      ' ' + d.toLocaleTimeString('es-ES', {hour: '2-digit', minute: '2-digit'});
  }
}
